import { CommanderThunkAction } from '@mews-commander/types';
import { createFetchAction } from '@mews-commander/utils';
import { setServiceOrders } from '../ducks/serviceOrders';
import prefix from '../prefix';

interface FetchServiceOrderParams {
    serviceOrderIds: string[];
}

const FETCH_SERVICE_ORDERS = prefix('FETCH_SERVICE_ORDERS');

export const fetchServiceOrders =
    ({ serviceOrderIds }: FetchServiceOrderParams): CommanderThunkAction =>
    async (dispatch, getState, { repositories }) => {
        const promise = repositories.serviceOrders.getAll({ serviceOrderIds }).then(({ serviceOrders }) =>
            // @ts-expect-error
            dispatch(setServiceOrders({ serviceOrders }))
        );

        return dispatch(createFetchAction(FETCH_SERVICE_ORDERS, promise));
    };
